import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Toolbar,
  Stack,
  Button,
  CircularProgress,
} from '@mui/material';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useUser, useUserDispatch } from '@/providers';
import { SET_USER } from '@/actions/types';

import { clearErrorMessage } from '../../actions/errorMessage';
import ProfileForm from './ProfileForm';
import { updateUser } from '../../actions/user';
import TermsOfService from './TermsOfService';

export default function AccountSignup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useUser();
  const userDispatch = useUserDispatch();
  const [loading, setLoading] = useState(false);
  const [display_terms, setDisplayTerms] = useState(false);
  const [form_values, setFormValues] = useState({ terms_accepted: false });

  useEffect(() => {
    return () => {
      dispatch(clearErrorMessage());
    };
  }, [dispatch]);

  const handleProfileSubmit = async () => {
    window.gtag('event', 'sign_up_profile_submitted', {
      customer_uuid: user.id,
    });
    setDisplayTerms(true);
  };

  const handleSubmitTerms = async () => {
    setLoading(true);
    window.gtag('event', 'sign_up_complete', {
      customer_uuid: user.id,
    });
    try {
      const updatedUser = await updateUser({
        terms_accepted: form_values.terms_accepted,
        terms_version: '2025-10-22',
      });
      if (updatedUser) {
        userDispatch({ type: SET_USER, payload: updatedUser });
      }
      navigate('/dashboard');
    } catch (error) {
      console.error('Failed to update user:', error);
      setLoading(false);
    }
  };

  if (!user) {
    navigate('/');
    return <div>Redirecting...</div>;
  }
  if (display_terms) {
    return (
      <Container>
        <TermsOfService setValues={setFormValues} />
        <Toolbar>
          <Stack spacing={2} direction='row'>
            <Button
              variant='contained'
              color='brand'
              onClick={handleSubmitTerms}
              disabled={!form_values.terms_accepted || loading}
              startIcon={loading ? <CircularProgress size={20} /> : undefined}
            >
              Submit
            </Button>
            <Button
              variant='outlined'
              onClick={() => {
                setFormValues({ terms_accepted: false });
                setDisplayTerms(false);
              }}
              disabled={loading}
            >
              Cancel
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    );
  } else {
    return (
      <Container>
        <Typography variant='h5'>New Account Signup</Typography>
        <br />
        <ProfileForm onSubmit={handleProfileSubmit} />
      </Container>
    );
  }
}
